import { DataGrid, Form, TagBox } from 'devextreme-react';
import './ConfigReportes.scss';
import { Column, Item, LoadPanel, Paging, SearchPanel, Toolbar, Button, Editing } from 'devextreme-react/data-grid';
import { useCallback, useEffect, useRef, useState } from 'react';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { ReportTypeList } from '../../types/types.reports';
import { useApiConfiguration } from '../../api/api.configuration';
import { XmlFile } from '../../images/icons';
import { FormPopup, newToast } from '../../components';
import LoadPnl from 'devextreme-react/load-panel';
import { Button as ButtonItem } from 'devextreme-react';
import { Item as ItemF, Label } from 'devextreme-react/form';
import { useAppSelector } from '../../contexts/hooks';
import { useApiReports } from '../../api/api.reports';

const currentFilters = {
  downloadType: undefined,
};

const priorityEntities = [
  { label: 'Completo', value: 1 },
  { label: 'Solo reporte', value: 2 },
];

const Index = () => {
  const gridRef = useRef<DataGrid>(null);
  const { getReports, updateReport, newReport } = useApiConfiguration();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [modalvisible, setModalVisible] = useState(false);
  const [modalPermissions, setModalPermissions] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState<number[]>([]);
  const [modalCreateReport, setModalCreateReport] = useState(false);
  const [isEditingReport, setIsEditingReport] = useState(false);
  const [newReportData, setNewReportData] = useState<any>({
    Rp_Nombre: '',
    Rp_Tipo: 4,
    Rp_Permisos: '-1',
    Rp_Reporte: null,
    Rp_Query: '',
    Rp_Filtros: '[]',
    Rp_Estado: true,
  });
  const [filters, setFilters] = useState<any[]>([]);
  const [modalFilterDesigner, setModalFilterDesigner] = useState(false);
  const [currentFilter, setCurrentFilter] = useState<any>(null);
  const [editingFilterIndex, setEditingFilterIndex] = useState<number | null>(null);
  const lstUsuariosPerfiles = useAppSelector((x) => x.configuration.Data?.UsuariosPerfiles)?.filter((x) => x.Pe_Estado && x.Pe_Id !== 2);
  const comboboxDataSource = useAppSelector((x) => x.configuration.Data?.ComboBox);
  const { createControlsBoard, updateControlsBoard } = useApiReports();
  const customDataSrc = new CustomStore({
    key: 'Rp_Id',
    load: () =>
      Promise.resolve({
        data: data,
        totalCount: 0,
      }),
    remove: (key) => {
      return new Promise((resolve) => {
        resolve();
      });
    },
  });

  const fetchData = () => {
    getReports().then((res) => {
      setData(res);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const customData = new DataSource({
    store: customDataSrc,
    reshapeOnPush: true,
  });

  const handleLoadXml = (e: any) => {
    if (e.row.data.Rp_Tipo === 4) {
      newToast('WARNING', 'No se puede cargar el xml en este tipo de reporte', 5);
      return;
    }
    //Abrir el administrador de a archivos para que el usuario seleccione el archivo xml, luego dejarlo en una variable para luego enviarlo al servidor
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.xml';
    fileInput.onchange = (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setLoading(true);
          const xmlContent = reader.result;
          // Aquí puedes enviar el contenido XML al servidor o procesarlo como desees
          const data = {
            ...e.row.data,
            Rp_Reporte: xmlContent,
          };
          updateReport(e.row.data.Rp_Id, data)
            .then((res) => {
              if (res) {
                fetchData();
              }
            })
            .finally(() => {
              setLoading(false);
            });
        };
        reader.readAsText(file);
      }
    };
    fileInput.click();
  };

  const handleDownLoad = (e: any) => {
    if (e.row.data.Rp_Tipo === 4) {
      newToast('WARNING', 'No es posible descargar reportes tipo tableros de control', 5);
      return;
    }
    setSelectedItem(e.row.data);
    setModalVisible(true);
  };

  const handlePermissions = (e: any) => {
    const { Rp_Id, Rp_Nombre } = e.row.data;
    setSelectedItem(e.row.data);

    // Inicializar selectedPermissions basado en Rp_Permisos
    if (e.row.data.Rp_Permisos === '-1') {
      // Si es -1, seleccionar todos los perfiles
      setSelectedPermissions(lstUsuariosPerfiles?.map((x) => x.Pe_Id) || []);
    } else if (typeof e.row.data.Rp_Permisos === 'string' && e.row.data.Rp_Permisos) {
      // Si es una cadena con IDs separados por comas
      setSelectedPermissions(
        e.row.data.Rp_Permisos.split(',')
          .map((id) => parseInt(id.trim()))
          .filter((id) => !isNaN(id))
      );
    } else {
      // Por defecto, ningún permiso seleccionado
      setSelectedPermissions([]);
    }

    setModalPermissions(true);
  };

  const loadReport = useCallback(() => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.json';
    fileInput.onchange = (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          const jsonContent = reader.result;
          const data = JSON.parse(jsonContent as string);
          delete data.Rp_Id; // Eliminar el id para que no se envíe al servidor
          if (data.Rp_Tipo === 5 || data.Rp_Tipo === 1) {
            newToast('WARNING', 'No es posible cargar reportes del sistema ni tableros de control', 5);
            return;
          }
          setLoading(true);
          newReport(data)
            .then((res) => {
              if (res) {
                fetchData();
              }
            })
            .finally(() => {
              setLoading(false);
            });
        };
        reader.readAsText(file);
      }
    };
    fileInput.click();
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalVisible(false);
  }, [setModalVisible]);

  const handleCloseModalPermissions = useCallback(() => {
    setModalPermissions(false);
    setSelectedPermissions([]);
  }, [setModalPermissions]);

  const handleSavePermissions = useCallback(() => {
    alert('Guardando permisos...');
    if (!selectedItem) return;

    // Si no hay permisos seleccionados, enviar "-1" (todos tienen acceso)
    // Si hay permisos seleccionados, enviar los IDs separados por comas
    const newPermissions = selectedPermissions.length === 0 ? '-1' : selectedPermissions.join(',');
    const updatedItem = { ...selectedItem, Rp_Permisos: newPermissions };

    setLoading(true);
    alert('Permisos actualizados: ' + newPermissions);
    updateReport(selectedItem.Rp_Id, updatedItem)
      .then((res) => {
        if (res) {
          fetchData();
          setModalPermissions(false);
          setSelectedPermissions([]);
          newToast('SUCCESS', 'Permisos actualizados correctamente', 3);
        }
      })
      .catch(() => {
        newToast('ERROR', 'Error al actualizar los permisos', 5);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectedItem, selectedPermissions, updateReport, fetchData]);

  const handleClicApply = useCallback(() => {
    if (!currentFilters.downloadType) {
      newToast('WARNING', 'Seleccione el tipo de descarga', 5);
      return;
    }
    setModalVisible(false);
    // Aquí puedes manejar la lógica de aplicar los cambios
    if (currentFilters.downloadType === 1) {
      const blob = new Blob([JSON.stringify(selectedItem)], { type: 'text/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${selectedItem.Rp_Nombre}.json`;
      a.click();
      URL.revokeObjectURL(url);
      return;
    }

    if (currentFilters.downloadType === 2) {
      const blob = new Blob([selectedItem.Rp_Reporte], { type: 'text/xml' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${selectedItem.Rp_Nombre}.xml`;
      a.click();
      URL.revokeObjectURL(url);
    }
  }, [currentFilters, selectedItem]);

  const handleCreateReport = useCallback(() => {
    setIsEditingReport(false);
    setNewReportData({
      Rp_Nombre: '',
      Rp_Tipo: 4,
      Rp_Permisos: '-1',
      Rp_Reporte: null,
      Rp_Query: '',
      Rp_Filtros: '[]',
      Rp_Estado: true,
    });
    setFilters([]);
    setModalCreateReport(true);
  }, []);

  const handleEditReport = useCallback((e: any) => {
    if (e.row.data.Rp_Tipo !== 4) {
      newToast('WARNING', 'Solo se pueden editar reportes tipo tablero de control', 5);
      return;
    }

    setIsEditingReport(true);
    setNewReportData(e.row.data);

    // Parsear los filtros del reporte
    try {
      const parsedFilters = e.row.data.Rp_Filtros ? JSON.parse(e.row.data.Rp_Filtros) : [];
      setFilters(parsedFilters);
    } catch (error) {
      console.error('Error parsing filters:', error);
      setFilters([]);
    }

    setModalCreateReport(true);
  }, []);

  const handleCloseCreateReport = useCallback(() => {
    setModalCreateReport(false);
    setFilters([]);
    setIsEditingReport(false);
  }, []);

  const handleSaveReport = useCallback(() => {
    if (!newReportData.Rp_Nombre || !newReportData.Rp_Query) {
      newToast('WARNING', 'Complete los campos requeridos', 5);
      return;
    }

    // Validar que si existen filtros, el query contenga el marcador [filters]
    if (filters.length > 0 && !newReportData.Rp_Query.includes('[filters]')) {
      newToast('WARNING', 'El query debe contener el marcador [filters] para aplicar los filtros configurados', 5);
      return;
    }

    setLoading(true);
    const reportToSave = {
      ...newReportData,
      Rp_Filtros: JSON.stringify(filters),
    };

    const savePromise = isEditingReport ? updateControlsBoard(reportToSave, newReportData.Rp_Id) : createControlsBoard(reportToSave);

    savePromise
      .then((res) => {
        if (res) {
          fetchData();
          setModalCreateReport(false);
          setFilters([]);
          setIsEditingReport(false);
          newToast('SUCCESS', isEditingReport ? 'Reporte actualizado correctamente' : 'Reporte creado correctamente', 3);
        }
      })
      .catch(() => {
        newToast('ERROR', isEditingReport ? 'Error al actualizar el reporte' : 'Error al crear el reporte', 5);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [newReportData, filters, isEditingReport, createControlsBoard, updateControlsBoard, fetchData]);

  const handleAddFilter = useCallback(() => {
    setCurrentFilter({
      label: '',
      typeCondition: '=',
      equivalence: '',
      type: 'dxTextBox',
      Combobox: null,
      value: '',
      required: false,
      min: '',
      max: '',
      order: filters.length + 1,
      mask: '',
    });
    setEditingFilterIndex(null);
    setModalFilterDesigner(true);
  }, [filters.length]);

  const handleEditFilter = useCallback(
    (index: number) => {
      setCurrentFilter({ ...filters[index] });
      setEditingFilterIndex(index);
      setModalFilterDesigner(true);
    },
    [filters]
  );

  const handleDeleteFilter = useCallback(
    (index: number) => {
      const updatedFilters = filters.filter((_, i) => i !== index);
      setFilters(updatedFilters);

      // Si eliminamos el último filtro, quitar el marcador [filters] del query
      if (updatedFilters.length === 0 && newReportData.Rp_Query.includes('[filters]')) {
        const cleanedQuery = removeFiltersMarker(newReportData.Rp_Query);
        setNewReportData({ ...newReportData, Rp_Query: cleanedQuery });
      }
    },
    [filters, newReportData]
  );

  const removeFiltersMarker = (query: string): string => {
    if (!query) return query;

    let cleanedQuery = query;

    // Remover "AND [filters]"
    cleanedQuery = cleanedQuery.replace(/\s+AND\s+\[filters\]\s*/gi, ' ');

    // Remover "[filters] AND" (por si acaso)
    cleanedQuery = cleanedQuery.replace(/\s+\[filters\]\s+AND\s+/gi, ' ');

    // Remover solo [filters] si quedó
    cleanedQuery = cleanedQuery.replace(/\s+\[filters\]\s*/gi, ' ');

    // Limpiar espacios múltiples
    cleanedQuery = cleanedQuery.replace(/\s+/g, ' ').trim();

    return cleanedQuery;
  };

  const handleSaveFilter = useCallback(() => {
    if (!currentFilter?.label || !currentFilter?.equivalence) {
      newToast('WARNING', 'Complete los campos requeridos del filtro', 5);
      return;
    }

    let updatedFilters: any[];
    if (editingFilterIndex !== null) {
      updatedFilters = filters.map((f, i) => (i === editingFilterIndex ? currentFilter : f));
    } else {
      updatedFilters = [...filters, currentFilter];
    }

    setFilters(updatedFilters);

    // Si es el primer filtro, insertar automáticamente [filters] en el query
    if (filters.length === 0 && newReportData.Rp_Query && !newReportData.Rp_Query.includes('[filters]')) {
      const updatedQuery = insertFiltersMarker(newReportData.Rp_Query);
      setNewReportData({ ...newReportData, Rp_Query: updatedQuery });
    }

    setModalFilterDesigner(false);
    setCurrentFilter(null);
    setEditingFilterIndex(null);
  }, [currentFilter, editingFilterIndex, filters, newReportData]);

  const insertFiltersMarker = (query: string): string => {
    if (!query || query.trim() === '') return query;

    const queryUpper = query.toUpperCase();
    const queryTrimmed = query.trim();

    // Buscar cláusulas que deben ir después de [filters]
    const afterFiltersClauses = ['GROUP BY', 'HAVING', 'ORDER BY', 'OFFSET', 'FETCH', 'FOR XML', 'FOR JSON', 'OPTION'];

    let insertPosition = -1;
    let clauseFound = '';

    // Encontrar la primera cláusula que debe ir después de [filters]
    for (const clause of afterFiltersClauses) {
      const pos = queryUpper.indexOf(clause);
      if (pos !== -1 && (insertPosition === -1 || pos < insertPosition)) {
        insertPosition = pos;
        clauseFound = clause;
      }
    }

    // Si encontramos una cláusula, insertar [filters] antes de ella
    if (insertPosition !== -1) {
      const beforeClause = queryTrimmed.substring(0, insertPosition).trim();
      const afterClause = queryTrimmed.substring(insertPosition).trim();

      // Verificar si ya hay un WHERE
      const hasWhere = beforeClause.toUpperCase().includes('WHERE');

      if (hasWhere) {
        // Si ya hay WHERE, agregar AND [filters]
        return `${beforeClause} AND [filters] ${afterClause}`;
      } else {
        // Si no hay WHERE, solo agregar [filters] (sin WHERE)
        return `${beforeClause} [filters] ${afterClause}`;
      }
    }

    // Si no hay cláusulas posteriores, agregar al final
    const hasWhere = queryUpper.includes('WHERE');

    if (hasWhere) {
      // Si ya hay WHERE, agregar AND [filters] al final
      return `${queryTrimmed} AND [filters]`;
    } else {
      // Si no hay WHERE, agregar solo [filters] al final (sin WHERE)
      return `${queryTrimmed} [filters]`;
    }
  };

  const handleCloseFilterDesigner = useCallback(() => {
    setModalFilterDesigner(false);
    setCurrentFilter(null);
    setEditingFilterIndex(null);
  }, []);

  return (
    <div className={'view crm-contact-list'}>
      <LoadPnl className='load-panel' visible={loading} showIndicator={true} showPane={true} shadingColor={'rgba(0,0,0,0.4)'} />
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' dataSource={customData} ref={gridRef} height='100%' repaintChangesOnly={true} highlightChanges={false} rowAlternationEnabled={true} showColumnLines={true}>
          <LoadPanel enabled={true} />
          <Editing allowUpdating={true} allowDeleting={false} mode='cell' />
          <SearchPanel visible placeholder='Buscar' />
          <Paging enabled={false} />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Reportes del sistema</div>
            </Item>
            <Item>
              <ButtonItem icon='refresh' onClick={fetchData} hint='Actualizar' />
            </Item>
            <Item>
              <ButtonItem icon='add' onClick={handleCreateReport} hint='Crear tablero de control' />
            </Item>
            <Item>
              <ButtonItem icon='upload' onClick={loadReport} hint='Cargar reporte' />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column dataField='Rp_Nombre' caption='REPORTE' />
          <Column dataField='Rp_Tipo' caption='TIPO' cellRender={handleRenderTipo} width={150} alignment='center' />
          <Column type='buttons' caption='ACCIONES' width={150} alignment='center'>
            <Button hint='Editar tablero' icon='edit' onClick={handleEditReport} visible={(e) => e.row.data.Rp_Tipo === 4} />
            <Button hint='Cargar xml' icon={XmlFile} onClick={handleLoadXml} visible={(e) => e.row.data.Rp_Tipo !== 4} />
            <Button hint='Descargar reporte' icon='download' onClick={handleDownLoad} />
            <Button hint='Permisos del reporte' icon='imgarlock' onClick={handlePermissions} />
          </Column>
        </DataGrid>
      </div>
      <FormPopup title='Tipo de descarga' visible={modalvisible} setVisible={handleCloseModal} onSave={handleClicApply} width={400} loading={false} allowSave={false}>
        <Form validationGroup='ValidationForm' formData={currentFilters} labelLocation='left' className='plain-styled-form'>
          <ItemF isRequired dataField='downloadType' editorType='dxRadioGroup' editorOptions={{ items: priorityEntities, valueExpr: 'value', displayExpr: 'label', layout: 'horizontal' }}>
            <Label text=' ' />
          </ItemF>
        </Form>
      </FormPopup>

      <FormPopup title='Permisos del reporte' visible={modalPermissions} setVisible={handleCloseModalPermissions} onSave={handleSavePermissions} width={500} loading={loading} allowSave={false}>
        <div style={{ padding: '10px 0' }}>
          <p style={{ marginBottom: '15px', color: '#666' }}>Seleccione los perfiles que tendrán acceso a este reporte. Si no selecciona ninguno, todos los perfiles tendrán acceso.</p>
          <TagBox
            dataSource={lstUsuariosPerfiles}
            valueExpr='Pe_Id'
            displayExpr='Pe_Nombre'
            showSelectionControls={true}
            applyValueMode='useButtons'
            searchEnabled={true}
            multiline={true}
            placeholder='Seleccione los perfiles con acceso'
            value={selectedPermissions}
            onValueChanged={(e) => {
              setSelectedPermissions(e.value || []);
            }}
          />
        </div>
      </FormPopup>

      <FormPopup title={isEditingReport ? 'Editar tablero de control' : 'Crear tablero de control'} visible={modalCreateReport} setVisible={handleCloseCreateReport} onSave={handleSaveReport} width={800} loading={loading} allowSave={false}>
        <Form formData={newReportData} labelLocation='top' className='plain-styled-form'>
          <ItemF isRequired dataField='Rp_Nombre' editorType='dxTextBox' editorOptions={{ placeholder: 'Nombre del reporte' }}>
            <Label text='Nombre del reporte' />
          </ItemF>

          <ItemF
            isRequired
            dataField='Rp_Query'
            editorType='dxTextArea'
            editorOptions={{
              height: 150,
              placeholder: 'SELECT * FROM tabla [filters] ORDER BY columna',
            }}>
            <Label text='Consulta SQL' />
          </ItemF>

          {filters.length > 0 && (
            <div
              style={{
                padding: '8px 12px',
                backgroundColor: '#d4edda',
                border: '1px solid #28a745',
                borderRadius: '4px',
                marginBottom: '10px',
                fontSize: '13px',
                color: '#155724',
              }}>
              <strong>✓ Marcador de filtros:</strong> El marcador <code>[filters]</code> se insertó automáticamente en su consulta SQL.
              <br />
              <small>Los filtros se aplicarán en la posición correcta según la sintaxis SQL.</small>
            </div>
          )}

          <ItemF>
            <Label text='Filtros' />
            <div style={{ marginTop: '10px' }}>
              <ButtonItem text='Agregar filtro' icon='add' type='default' stylingMode='contained' onClick={handleAddFilter} />

              {filters.length > 0 && (
                <DataGrid dataSource={filters} showBorders={true} rowAlternationEnabled={true} style={{ marginTop: '10px' }} height={300}>
                  <Column dataField='order' caption='Orden' width={70} alignment='center' />
                  <Column dataField='label' caption='Etiqueta' />
                  <Column dataField='type' caption='Tipo de campo' width={130} />
                  <Column dataField='typeCondition' caption='Condición' width={100} alignment='center' />
                  <Column dataField='required' caption='Requerido' width={100} alignment='center' dataType='boolean' />
                  <Column type='buttons' width={100} alignment='center'>
                    <Button icon='edit' onClick={(e) => e.row && handleEditFilter(e.row.rowIndex)} />
                    <Button icon='trash' onClick={(e) => e.row && handleDeleteFilter(e.row.rowIndex)} />
                  </Column>
                </DataGrid>
              )}
            </div>
          </ItemF>
        </Form>
      </FormPopup>

      <FormPopup title={editingFilterIndex !== null ? 'Editar filtro' : 'Nuevo filtro'} visible={modalFilterDesigner} setVisible={handleCloseFilterDesigner} onSave={handleSaveFilter} width={600} loading={false} allowSave={false}>
        {currentFilter && (
          <Form
            formData={currentFilter}
            labelLocation='top'
            className='plain-styled-form'
            onFieldDataChanged={(e) => {
              if (e.dataField) {
                setCurrentFilter({ ...currentFilter, [e.dataField as string]: e.value });
              }
            }}>
            <ItemF isRequired dataField='label' editorType='dxTextBox' editorOptions={{ placeholder: 'Ej: Fecha' }}>
              <Label text='Etiqueta visible' />
            </ItemF>

            <ItemF isRequired dataField='equivalence' editorType='dxTextBox' editorOptions={{ placeholder: 'Ej: Ord_FechaCreacion' }}>
              <Label text='Campo equivalente (SQL)' />
            </ItemF>

            <ItemF
              isRequired
              dataField='type'
              editorType='dxSelectBox'
              editorOptions={{
                items: [
                  { value: 'dxTextBox', label: 'Texto' },
                  { value: 'dxNumberBox', label: 'Número' },
                  { value: 'dxDateBox', label: 'Fecha' },
                  { value: 'dxDateRangeBox', label: 'Rango de fechas' },
                  { value: 'dxSelectBox', label: 'Lista desplegable' },
                  { value: 'dxCheckBox', label: 'Casilla de verificación' },
                  { value: 'dxTagBox', label: 'Etiquetas múltiples' },
                ],
                valueExpr: 'value',
                displayExpr: 'label',
              }}>
              <Label text='Tipo de campo' />
            </ItemF>

            <ItemF
              isRequired
              dataField='typeCondition'
              editorType='dxSelectBox'
              editorOptions={{
                items: [
                  { value: '=', label: 'Igual (=)' },
                  { value: '!=', label: 'Diferente (!=)' },
                  { value: '>', label: 'Mayor que (>)' },
                  { value: '>=', label: 'Mayor o igual (>=)' },
                  { value: '<', label: 'Menor que (<)' },
                  { value: '<=', label: 'Menor o igual (<=)' },
                  { value: 'LIKE', label: 'Contiene (LIKE)' },
                  { value: 'IN', label: 'En lista (IN)' },
                  { value: 'BETWEEN', label: 'Entre (BETWEEN)' },
                ],
                valueExpr: 'value',
                displayExpr: 'label',
              }}>
              <Label text='Condición SQL' />
            </ItemF>

            {(currentFilter.type === 'dxSelectBox' || currentFilter.type === 'dxTagBox') && (
              <ItemF
                dataField='Combobox'
                editorType='dxSelectBox'
                editorOptions={{
                  dataSource: [{ Id: 'Estudios', Name: 'Estudios' }, ...(comboboxDataSource || [])],
                  valueExpr: 'Id',
                  displayExpr: 'Name',
                  placeholder: 'Seleccione origen de datos',
                  searchEnabled: true,
                }}>
                <Label text='Origen de datos (ComboBox)' />
              </ItemF>
            )}

            <ItemF dataField='required' editorType='dxCheckBox'>
              <Label text='Campo requerido' />
            </ItemF>

            <ItemF
              dataField='order'
              editorType='dxNumberBox'
              editorOptions={{
                min: 1,
                showSpinButtons: true,
              }}>
              <Label text='Orden' />
            </ItemF>

            {currentFilter.type === 'dxNumberBox' && (
              <>
                <ItemF dataField='min' editorType='dxNumberBox' editorOptions={{ placeholder: 'Valor mínimo' }}>
                  <Label text='Valor mínimo' />
                </ItemF>

                <ItemF dataField='max' editorType='dxNumberBox' editorOptions={{ placeholder: 'Valor máximo' }}>
                  <Label text='Valor máximo' />
                </ItemF>
              </>
            )}

            {(currentFilter.type === 'dxTextBox' || currentFilter.type === 'dxNumberBox') && (
              <ItemF dataField='mask' editorType='dxTextBox' editorOptions={{ placeholder: 'Ej: 000-000-0000' }}>
                <Label text='Máscara de formato' />
              </ItemF>
            )}
          </Form>
        )}
      </FormPopup>
    </div>
  );
};

const handleRenderTipo = (e: any) => {
  const tipo = e.value;
  const text = ReportTypeList.find((item) => item.value === tipo)?.label || 'Desconocido';
  return <span>{text}</span>;
};

export default Index;
